import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/page.client.tsx");
